<template>
  <div>
    <v-container fluid class="">
      <v-card>
        <v-card-title>{{ mode === 'all' ? 'All Users' : 'Available Users' }}</v-card-title>
        <template>
          <v-card>

           <v-skeleton-loader
              v-if="loading"
              class="mx-auto"
              type="table"
            ></v-skeleton-loader>

            <v-card-text>            
                <span v-for="(item, i) in displayedItems" :key="i">
                <v-chip small>{{item.firstName}} {{item.lastName}}</v-chip>
                </span>
            </v-card-text>

            <v-card-actions>
              <v-btn x-small @click="mode='all'" v-if="mode=='available'">Show All Users</v-btn>
              <v-btn x-small @click="mode='available'" v-else>Show Available Users</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import formatterMixin from "@/mixins/formatterMixin";
import { getStorage, setStorage } from "src/utils/helpers";
import _ from "lodash";

const SETTING_LIST_KEY = "timeClock-columns";
const defaultHeaders = [
  { text: "Name", value: "firstName", sortable: true, active: true },
];

export default {
  mixins: [formatterMixin],
  props: {
    clientId: Number,
    hideTitle: Boolean,
  },
  components: {
  },
  data: () => ({
    showTimeEntryForm: false,
    showForm: false,
    showDelete: false,
    selectedItem: {},
    namespace: "Time Clock",
    page: "Time Clock",
    usage: "usage",
    timer: null,
    tableOptions: {},
    mode: 'all',
    isTimeClockRunningOptions: [
      { text: "Show All", value: null },
      { text: "Show Running TimeClock", value: true },
      { text: "Show Not Running TimeClock", value: false },
    ],

    hideCompleted: false,

    filter: {
      SearchTerm: "",
      clientId: "",
      status: "",
      isTimeClockRunning: true,
      hideCompleted: null,
      tags: [],
    },
    headers: defaultHeaders.map((item) => {
      let savedHeaders = getStorage(SETTING_LIST_KEY) || [];
      let nowHeader = savedHeaders.filter(
        (saved) => saved.value === item.value
      );

      if (nowHeader) {
        nowHeader = nowHeader[0];
      }
      return {
        ...item,
        ...nowHeader,
      };
    }),
  }),
  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account.data,
      loading: (state) => state.timeclock.loadingTable,
      totalItems: (state) => state.timeclock.metaData.totalEntries,
      dataItems: (state) => state.user.dataAvailable,
      dataAllItems: (state) => state.user.data
    }),

    displayedItems() {
      return this.mode == 'all'
        ? this.dataAllItems.filter(item => item.isActive)
        : this.dataItems.filter(item => item.isActive);
    },

    computedFilter() {
      const { clientId, tags, status, SearchTerm } = this.filter;
      let { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
      let params = {
        PageNumber: page ? page : 1,
        PageSize: itemsPerPage > 0 ? itemsPerPage : 10,
      };

      params.OrderBy = sortBy.length > 0 && sortBy[0] ? sortBy[0] : null;

      if (params.OrderBy) {
        params.Ascending = sortDesc.length > 0 && sortDesc[0] ? false : true;
      } else {
        params.Ascending = false;
      }

      params.isTimeClockRunning = true;

      if (status) {
        params.status = status;
      }

      if (clientId) {
        params.clientId = clientId;
      }

      if (SearchTerm) {
        params.SearchTerm = SearchTerm;
      }

      if (tags && tags.length > 0) {
        params.tagsArray = [];
        tags.map((tag) => {
          params.tagsArray.push(tag);
        });
      }

      return params;
    },

    tags() {
      return this.filter.tags;
    },
    activeHeaders() {
      return this.headers.filter((header) => header.active);
    },
  },
  watch: {
    clientId(n) {
      if (n) {
        this.filter.clientId = n;
      }
    },
    headers: {
      handler() {
        setStorage(SETTING_LIST_KEY, this.headers);
      },
      deep: true,
    },

    tableOptions: {
      handler(n, o) {
        if (JSON.stringify(n) !== JSON.stringify(o)) {
          this.refresh();
        }
      },
      deep: true,
    },

    filter: {
      async handler() {
        await this.refresh(true);
      },
      deep: true,
    },
  },

  async mounted() {
    if (this.clientId) {
      this.filter.clientId = this.clientId;
    }
    await this.refresh();

    this.timer = setInterval(() => {
      this.refreshNoLoading();
    }, (60 * 1000));

    await this.getAll();
  },

  beforeDestroy() {
    if (this.clientId) {
      this.clearTableFilter();
    }
    clearInterval(this.timer);
  },

  methods: {

    ...mapActions({
      getAll:'user/getAll',
      getAllAvailable:'user/getAllAvailable'
    }),

    refresh: _.debounce(async function () {
      this.refreshTable(true);
    }, 500),

    async refreshTable() {
      const d = new Date();
      d.setHours(0, 0, 0, 0);     
      await this.getAllAvailable({
        dateStart: this.localToUtc(d).format("YYYY-MM-DDThh:mm"),
        dateEnd: this.localToUtc(d).add(1, "day").format("YYYY-MM-DDThh:mm"),
      });
    },

    async refreshNoLoading() {
      if (!this.loading) {
        await this.refreshTable(false);
      }
    },

    onTimeEntryForm(item) {
      this.showTimeEntryForm = true;
      this.selectedItem = item;
    },

    async clearTimeEntryForm() {
      this.showTimeEntryForm = false;
      this.selectedItem = {};
      await this.refreshNoLoading();
    },

    onEdit(item) {
      if (!this.hasAccess("timeclock.edit")) {
        return false;
      }
      this.showForm = true;
      this.selectedItem = item;
    },

    onDelete(item) {
      this.showDelete = true;
      this.selectedItem = item;
    },

    onAdd() {
      this.showForm = true;
      this.selectedItem = {};
    },

    clearForm() {
      this.showForm = false;
      this.selectedItem = {};
    },

    clearDelete() {
      this.showDelete = false;
      this.selectedItem = {};
    },
  },
};
</script>
